import React, { useState } from "react";

export default function HeroMobile({
  t,
  dir = "ltr",
  routes = {},
  UI = { garnet: "#8B1E3F", teal: "#008b8b", ochre: "#C49A6C" },
  bg = "/images/hero2.jpg",     // mobile-friendly background from /public/images
  logo = "/images/logo.svg",    // centered logo from /public/images
  star = "/images/star.svg",    // your star
  showStar = true,

  // floating language toggle inside the hero (Option B)
  showLangToggle = false,
  onToggleLang,
  toggleLabel,
}) {
  const hasLead = !!t?.heroLead;
  const [hideLogo, setHideLogo] = useState(false);

  return (
    <section
      aria-label="Mobile Hero"
      style={{
        position: "relative",
        minHeight: "72vh",
        backgroundImage: `url('${bg}')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        overflow: "hidden",
        color: "#fff",
      }}
    >
      {/* floating language toggle (top-right) */}
      {showLangToggle && (
        <button
          onClick={onToggleLang}
          style={{
            position: "absolute",
            top: 10,
            right: 10,
            zIndex: 4,
            borderRadius: 10,
            border: "1px solid rgba(0,0,0,0.15)",
            background: "rgba(255,255,255,0.9)",
            padding: "6px 10px",
            fontSize: 12,
            cursor: "pointer",
          }}
        >
          {toggleLabel}
        </button>
      )}

      {/* soft backdrop so content pops on bright photos */}
      <div
        aria-hidden
        style={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(to top, rgba(0,0,0,0.18), rgba(0,0,0,0.00) 40%)",
          zIndex: 1,
        }}
      />

      {/* single, no-repeat star */}
      {showStar && (
        <img
          src={star}
          alt=""
          style={{
            position: "absolute",
            top: 12,
            left: 12,
            width: 72,
            height: 72,
            opacity: 0.14,
            pointerEvents: "none",
            zIndex: 2,
          }}
        />
      )}

      {/* content (logo + headings only) */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 16,
          zIndex: 3,
          textAlign: "center",
        }}
      >
        <div style={{ maxWidth: "min(92vw, 540px)", display: "flex", flexDirection: "column", alignItems: "center", gap: 12 }}>
          {/* centered logo with fallback text if the file fails to load */}
          {!hideLogo ? (
            <img
              src={logo}
              alt={dir === "rtl" ? "شعار غرناطة" : "Granada Logo"}
              onError={() => setHideLogo(true)}
              style={{
                height: 84,
                width: "auto",
                display: "block",
                filter: "drop-shadow(0 2px 6px rgba(0,0,0,0.35))",
              }}
            />
          ) : (
            <div
              style={{
                fontWeight: 800,
                fontSize: 24,
                color: UI.garnet,
                background: "rgba(255,255,255,0.75)",
                display: "inline-block",
                padding: "6px 10px",
                borderRadius: 8,
              }}
            >
              Granada
            </div>
          )}

          {t?.heroTop && (
            <div
              style={{
                letterSpacing: 2.5,
                textTransform: "uppercase",
                fontSize: "clamp(10px, 3.5vw, 12px)",
                fontWeight: 700,
                color: UI.ochre,
                background: "rgba(255,255,255,0.7)",
                padding: "4px 8px",
                borderRadius: 6,
              }}
            >
              {t.heroTop}
            </div>
          )}

          <h1
            style={{
              fontSize: "clamp(22px, 7.5vw, 30px)",
              margin: "6px 0 4px",
              lineHeight: 1.1,
              color: UI.garnet,
              textShadow: "0 2px 6px rgba(0,0,0,0.25)",
            }}
          >
            {t?.heroTitle}
          </h1>

          {hasLead && (
            <p
              style={{
                fontSize: "clamp(13px, 4vw, 16px)",
                margin: 0,
                lineHeight: 1.45,
                color: "#111",
                background: "rgba(255,255,255,0.65)",
                padding: "8px 10px",
                borderRadius: 8,
                display: "inline-block",
              }}
            >
              {t.heroLead}
            </p>
          )}
        </div>
      </div>

      {/* designer credit */}
      {t?.designedBy && (
        <div
          style={{
            position: "absolute",
            bottom: 10,
            ...(dir === "rtl" ? { left: 14 } : { right: 14 }),
            color: "#fff",
            fontSize: 12,
            opacity: 0.9,
            fontWeight: 500,
            textShadow: "0 1px 3px rgba(0,0,0,0.45)",
            zIndex: 3,
            userSelect: "none",
            pointerEvents: "none",
          }}
        >
          {t.designedBy}
        </div>
      )}
    </section>
  );
}
